import { Component, ViewChild, ElementRef, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
declare var MediaRecorder: any;
// import RecordRTC from 'recordrtc';



interface ChatMessage {
  from: 'user' | 'bot';
  text: string;
  type?: 'text' | 'file';
}

interface Message {
  role: 'user' | 'assistant';
  text: string;
  stream?: boolean;
}

@Component({
  selector: 'app-ai-chatbot',
  templateUrl: './ai-chatbot.component.html',
  styleUrls: ['./ai-chatbot.component.css']
})
export class AiChatbotComponent implements OnInit {
  @ViewChild('chatBox') chatBox!: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  

  reportList: string[] = [
  'Previous Month Annexure Report',
  'Previous Month Government Annexure Report',
  'Previous Month MMU-wise Patient Registration Report',
  'Previous Month MMU-wise Consultation Report',
  'MMU-wise Available Stock Report'
];
    
isDarkMode = false;
  API_BASE_URL = location.href.includes('localhost') ? environment.applicationURL : location.origin;
  API_BASE_URL_ChatDb = location.href.includes('localhost') ? environment.applicationURL : location.origin +`${'/AIPyService/chatbotdb/'}`;


  messages: ChatMessage[] = [
    { from: 'bot', text: "Hello! I'm your healthcare assistant. How can I help you today?" }
  ];
  userInput: string = '';
  isSending = false;
  backendConnected = false;

  // Voice
  isRecording = false;
  mediaRecorder!:any;
  audioChunks: Blob[] = [];

  // File
  selectedFile: File | null = null;
  uploadingFile = false;
  uploadProgress = 0;
  transcribeText : any = '';

  // live chat
  isStreamingActive = false;
recorder: any;
stream: MediaStream | null = null;
audioContext: AudioContext | null = null;
analysers: AnalyserNode | null = null;
silenceTimer: any;
audioURL: string | null = null;
private streamingAudioChunks: Blob[] = [];

  dots: { scale: number; opacity: number }[] = [];
private numDots = 180;
// private analyser!: AnalyserNode | undefined;
private audioCtx!: AudioContext;
private dataArray!: Uint8Array | null;
private rafId = 0;
private micStream!: MediaStream;
private waveBuffer: number[] = [];
// isDBMode = false; isInsert = false; 
selectedMode: 'DB' | 'Insert' | null = 'DB';
private audioPlayer: HTMLAudioElement;
  interruptionDetected: any;
  conversationHistory: any;

   conversationActive = false;
  isProcessing = false;
  currentLanguage = 'en';
  private aiSpeaking = false;
  private mediaStream: MediaStream | null = null;
  private silenceTimeout: any = null;
   private interruptionMonitorActive = false;
  // private audioPlayer: HTMLAudioElement | undefined;
  statusText = 'Tap to start conversation';
  statusClass = '';
  waveformActive = false;
  showEmptyState = true;
  private readonly interruptionThreshold = 0.02;
   private vadCheckInterval: any = null;
 
analyser: AnalyserNode | any;
  askeddata: any;


  constructor( public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private http : HttpClient,
    private AuthenticationService : AuthenticationService
  ) {
    this.audioPlayer = new Audio();
  }

  ngOnInit(): void {
      window.addEventListener('message', (event) => {
    if (event.data?.type === 'EXPORT') {
      this.exportTableToExcel(); // API call
    }
  });
    // this.checkBackendStatus();
    this.conversationId = `web_user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    // this.loadConversationHistory();
    if (this.audioPlayer) {
      this.audioPlayer.style.display = 'none';
      document.body.appendChild(this.audioPlayer);
    }
  }

  closeModal() {
    this.activeModal.close();
  }


  toggleMode(mode: 'DB' | 'Insert') {
  if (this.selectedMode === mode) {
    // If clicking the same button, unselect it
    this.selectedMode = null;
  } else {
    // Select the clicked button
    this.selectedMode = mode;
  }
}

  // toggleDBMode() {
  // this.isDBMode = !this.isDBMode;
  // }

  formatMessage(message: string) {
    return message
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br>');
  }

  async checkBackendStatus() {
    try {
      const response = await fetch(`${this.API_BASE_URL}health`);
      this.backendConnected = response.ok;
    } catch {
      this.backendConnected = false;
    }
  }

async sendMessage() {
  const message = this.userInput.trim();
  if (!message) return;

  this.addMessage('user', message);
  this.userInput = '';
  this.isSending = true;

  try {
    let apiUrl = '';
    let body: any = {};

    if (this.selectedMode === 'DB') {
      // DB mode active → use alternate API
      apiUrl = `${this.API_BASE_URL}/ask`;
      // apiUrl = `https://hmsdev.dhanushinfotech.com/AIPyService/chatbot/ask`;
      body = { question: message };
    } 
    // else if(this.selectedMode === 'Insert'){
    //   apiUrl = `${this.API_BASE_URL_ChatDb}query`;
    //   // apiUrl = `https://hmsdev.dhanushinfotech.com/AIPyService/chatbot/query`;
    //   body = { query: message };
    // }
    // else {
    //   // Default chat mode
    //   apiUrl = `${this.API_BASE_URL}api/chat/`;
    //   body = { message, user_id: 'web_user', chat_type: 'general', conversation_id: '' };
    // }

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    const data = await response.json();
    this.askeddata = data;

    let botResponse = '';


    if (this.selectedMode === 'DB' && data.formatted_message) {
      // Clean up and  format the DB message
      const cleanMsg = data.formatted_message
        .replace(/^Showing top (\d+) of (\d+) records:/, '**Showing top $1 of $2 records:**')
        .replace(/•/g, '• ')
        .replace(/\n{2,}/g, '\n')
        .trim();

     botResponse = data.columns   ? data.formatted_message : this.formatMessage(cleanMsg);
    } 
    else if(this.selectedMode === 'Insert' && data?.result?.reasoning){
      const cleanMsg = data?.result?.reasoning
      botResponse = this.formatMessage(cleanMsg);
    }
    else {
      botResponse = this.formatMessage(data.response || data.answer || 'Sorry, I could not process your request.');
    }

    this.addMessage('bot', botResponse);

  } catch {
    this.addMessage('bot', this.formatMessage('Error connecting to backend.'));
  } finally {
    this.isSending = false;
  }
}




//  addMessage(from: 'user' | 'bot', text: string) {
//   this.messages.push({ from, text });
//   setTimeout(() => this.scrollToBottom(), 0);
// }

addMessage(from: 'user' | 'bot', text: string) {
  const msg: any = { from, text };

  if (this.isTableHTML(text)) {
    msg.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
      this.createHTMLForMessage(text)
    );
  }

  this.messages.push(msg);

  setTimeout(() => this.scrollToBottom(), 0);
}

  scrollToBottom() {
    if (this.chatBox) {
      this.chatBox.nativeElement.scrollTop = this.chatBox.nativeElement.scrollHeight;
    }
  }

  // Voice Chat
  // async toggleVoiceChat() {
  //   if (!this.isRecording) await this.startRecording();
  //   else await this.stopRecording();
  // }

  // async startRecording() {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  //     this.mediaRecorder = new MediaRecorder(stream);
  //     this.audioChunks = [];

  //     this.mediaRecorder.ondataavailable = (event) => {
  //       if (event.data.size > 0) this.audioChunks.push(event.data);
  //     };

  //     this.mediaRecorder.onstop = async () => {
  //       const blob = new Blob(this.audioChunks, { type: 'audio/webm' });
  //       await this.processVoiceInput(blob);
  //       stream.getTracks().forEach(track => track.stop());
  //     };

  //     this.mediaRecorder.start();
  //     this.isRecording = true;
  //     this.addMessage('bot', '🎤 Recording... Speak clearly and click "Stop Recording" when done.');
  //   } catch {
  //     this.addMessage('bot', 'Error accessing microphone.');
  //   }
  // }

  // async stopRecording() {
  //   if (this.mediaRecorder && this.isRecording) {
  //     this.mediaRecorder.stop();
  //     this.isRecording = false;
  //     this.addMessage('bot', '⏳ Processing your voice message...');
  //   }
  // }


async toggleVoiceChat() {
  if (!this.isRecording) await this.startRecording();
  else await this.stopRecording();
}

async startRecording() {
  try {
    // this.micStream = await navigator.mediaDevices.getUserMedia({ audio: true });
    this.micStream = await navigator.mediaDevices.getUserMedia({
  audio: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true
  }
});
    this.audioCtx = new AudioContext();
    const source = this.audioCtx.createMediaStreamSource(this.micStream);
    this.analyser = this.audioCtx.createAnalyser();
    this.analyser.fftSize = 64;
    source.connect(this.analyser);

    const bufferLength = this.analyser.frequencyBinCount;
    this.dataArray = new Uint8Array(bufferLength);

    // Initialize dots & buffer
    this.dots = Array.from({ length: this.numDots }, () => ({ scale: 1, opacity: 0.6 }));
    this.waveBuffer = Array(this.numDots).fill(0); // buffer starts empty

    this.mediaRecorder = new MediaRecorder(this.micStream);
    this.audioChunks = [];
    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) this.audioChunks.push(event.data);
    };

    this.mediaRecorder.onstop = async () => {
      cancelAnimationFrame(this.rafId);
      const blob = new Blob(this.audioChunks, { type: 'audio/webm' });
      await this.processVoiceInput(blob);
      this.micStream.getTracks().forEach(track => track.stop());
      if (this.audioCtx) this.audioCtx.close();
    };

    this.mediaRecorder.start();
    this.isRecording = true;
    this.animateDots(); // start flowing animation
    // this.addMessage('bot', '🎤 Recording... Click mic again to stop.');
  } catch {
    this.addMessage('bot', 'Error accessing microphone.');
  }
}


private animateDots = () => {
  if (this.analyser) {
    this.analyser.getByteFrequencyData(this.dataArray);
  }

  // Calculate average amplitude of current frame
  let sum = 0;
  for (let i = 0; i < this.dataArray.length; i++) sum += this.dataArray[i];
  const avg = sum / this.dataArray.length / 255; // normalized 0 → 1

  // Push new value to buffer & remove oldest to make it flow left
  this.waveBuffer.push(avg);
  if (this.waveBuffer.length > this.numDots) this.waveBuffer.shift();

  // Update each dot from buffer
  for (let i = 0; i < this.waveBuffer.length; i++) {
    const value = this.waveBuffer[i];
    this.dots[i].scale = 0.5 + value * 3;   // adjust scaleY
    this.dots[i].opacity = 1;
  }

  this.rafId = requestAnimationFrame(this.animateDots);
};



async stopRecording() {
  if (this.mediaRecorder && this.isRecording) {
    this.isRecording = false;
    cancelAnimationFrame(this.rafId);
    this.mediaRecorder.stop();
    // this.addMessage('bot', '⏳ Processing your voice message...');
  }
}

  async processVoiceInput(blob: Blob) {
  if (!blob || blob.size === 0) {
    this.addMessage('bot', 'No audio recorded.');
    return;
  }

  const formData = new FormData();
  formData.append('audio_file', blob, 'recording.webm');
  formData.append('action', 'voice_chat');
  formData.append('user_id', 'voice_user');

  try {
    const response = await fetch(`${this.API_BASE_URL}api/voice/process`, { method: 'POST', body: formData });
    const json = await response.json();

    if (json.transcribed_text) {
      this.userInput = json.transcribed_text.trim();
      setTimeout(() => {
        const textarea = document.querySelector('textarea.no-glow') as HTMLTextAreaElement;
        if (textarea) {
          textarea.value = this.userInput;
          textarea.dispatchEvent(new Event('input')); 
        }
        // this.sendMessage();
      }, 200);
    } else {
      this.addMessage('bot', 'Sorry, could not recognize any speech.');
    }
  } catch (err) {
    console.error(err);
    this.addMessage('bot', 'Error processing voice input.');
  }
}


  // File Upload
  onFileSelect(event: any) {
    this.selectedFile = event.target.files[0] || null;
    if (this.selectedFile) this.uploadFile();
  }

  async uploadFile() {
    if (!this.selectedFile) return alert('Select a file first.');

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('user_id', 'web_user');

    this.uploadingFile = true;
    this.uploadProgress = 0;

    this.addMessage('bot', `📤 Uploading **${this.selectedFile.name}**...`);

    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${this.API_BASE_URL}api/uploads/file`, true);

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) this.uploadProgress = Math.round((event.loaded / event.total) * 100);
    };

    xhr.onload = () => {
      this.uploadingFile = false;
      this.uploadProgress = 0;

      if (xhr.status === 200) {
        const data = JSON.parse(xhr.responseText);

        if (data.extracted_text && data.extracted_text.trim().length > 0) {
          // Format summary: split by \n and add <br> for HTML rendering
          const formattedSummary = data.extracted_text.replace(/\n/g, '<br>');
          this.addMessage('bot', formattedSummary);
        } else {
          this.addMessage('bot', '⚠️ Sorry, we could not extract any summary from this file.');
        }

        this.selectedFile = null;
      } else {
        this.addMessage('bot', '❌ Error uploading file.');
        this.selectedFile = null;
      }
    };

    xhr.onerror = () => {
      this.addMessage('bot', '❌ Error uploading file.');
      this.uploadingFile = false;
      this.uploadProgress = 0;
      this.selectedFile = null;
    };

    xhr.send(formData);
  }



  async pollForProcessedText(fileId: string) {
    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${this.API_BASE_URL}api/uploads/status/${fileId}`);
        const data = await res.json();

        if (data.processed && data.extracted_text) {
          this.addMessage('bot', data.extracted_text);
          clearInterval(interval);
        }
      } catch {
        // ignore errors
      }
    }, 3000);
  }

  // Health tips
  async getHealthTips() {
    this.isSending = true; // show loading animation
    try {
      const response = await fetch(`${this.API_BASE_URL}api/chat/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: 'Give me daily health tips', user_id: 'web_user', chat_type: 'tips' })
      });
      const data = await response.json();

      const formattedResponse = this.formatMessage(
        data.response || 'Stay hydrated, exercise, sleep well, and eat balanced meals.'
      );

      this.addMessage('bot', formattedResponse);
    } catch {
      this.addMessage('bot', 'Error fetching health tips.');
    } finally {
      this.isSending = false; // hide loading animation
    }
  }




// //Voiced Mode

//  async toggleConversation() {
//     if (this.conversationActive) {
//       this.stopConversation();
//     } else {
//       await this.startConversation();
//     }
//   }

//   // -------------------------------
//   // Start conversation
//   // -------------------------------
//   async startConversation() {
//     try {
//       this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });

//       this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
//       const source = this.audioContext.createMediaStreamSource(this.mediaStream);
//       this.analyser = this.audioContext.createAnalyser();
//       this.analyser.fftSize = 2048;
//       source.connect(this.analyser);

//       this.conversationActive = true;
//       this.showEmptyState = false;
//       this.statusText = 'Listening...';
//       this.statusClass = 'listening';

//       this.monitorUserInterruption(); // Continuous VAD
//       this.startListeningCycle();     // Start first recording
//     } catch (err) {
//       console.error('Microphone error:', err);
//       this.statusText = 'Could not access microphone';
//       this.statusClass = 'error';
//     }
//   }
// animationFrameId: number | null = null;
//   // -------------------------------
//   // Stop conversation
//   // -------------------------------
//  stopConversation() {
//   console.log('Stopping conversation...');

//   // ✅ Mark conversation inactive
//   this.conversationActive = false;
//   this.aiSpeaking = false;
//   this.interruptionDetected = true;

//   // ✅ Stop microphone
//   if (this.mediaStream) {
//     this.mediaStream.getTracks().forEach(track => track.stop());
//     this.mediaStream = null;
//   }

//   // ✅ Stop audio playback
//   if (this.audioPlayer) {
//     this.audioPlayer.pause();
//     this.audioPlayer.currentTime = 0;
//     this.audioPlayer.src = ''; // remove source to prevent replay
//   }

//   // ✅ Stop speech synthesis
//   if ('speechSynthesis' in window) {
//     speechSynthesis.cancel();
//   }

//   // ✅ Stop any intervals / monitoring loops
//   if (this.vadCheckInterval) {
//     clearInterval(this.vadCheckInterval);
//     this.vadCheckInterval = null;
//   }
//   if (this.silenceTimeout) {
//     clearTimeout(this.silenceTimeout);
//     this.silenceTimeout = null;
//   }
//   if (this.animationFrameId) {
//     cancelAnimationFrame(this.animationFrameId);
//     this.animationFrameId = null;
//   }

//   // ✅ Reset UI
//   this.statusText = 'Tap to start conversation';
//   this.statusClass = '';
//   this.waveformActive = false;

//   console.log('Conversation fully stopped.');
// }



//   // -------------------------------
//   // Listening cycle
//   // -------------------------------
//   async startListeningCycle() {
//     if (!this.conversationActive || !this.mediaStream) return;

//     this.aiSpeaking = false;
//     this.interruptionDetected = false;

//     const chunks: BlobPart[] = [];
//     const recorder = new MediaRecorder(this.mediaStream);
//     this.mediaRecorder = recorder;

//     recorder.ondataavailable = (e) => { if (e.data.size > 0) chunks.push(e.data); };

//     recorder.onstop = async () => {
//       if (!this.conversationActive) return;
//       const audioBlob = new Blob(chunks, { type: 'audio/webm' });
//       await this.processVoiceAndRespond(audioBlob);
//     };

//     recorder.start();
//     this.statusText = 'Listening... Speak now';
//     this.statusClass = 'listening';
//     this.waveformActive = true;

//     // Auto-stop after 8 seconds
//     setTimeout(() => { if (recorder.state === 'recording') recorder.stop(); }, 8000);
//   }

//   // -------------------------------
//   // Process audio → API
//   // -------------------------------
//   async processVoiceAndRespond(audioBlob: Blob) {
//     if (!this.conversationActive) return;

//     try {
//       const formData = new FormData();
//       formData.append('audio_file', audioBlob, 'recording.webm');
//       formData.append('language', this.currentLanguage);
//       formData.append('action', 'voice_chat');
//       formData.append('user_id', 'voice_user');

//       const response = await fetch(`${this.API_BASE_URL}api/voice/stream`, { method: 'POST', body: formData });
//       if (!response.ok) throw new Error('API call failed');

//       const data = await response.json();
//       if (data.transcribed_text) this.addMessage('user', data.transcribed_text);
//       if (data.ai_response) {
//         this.addMessage('bot', data.ai_response);

//         this.aiSpeaking = true;
//         await this.speakText(data.ai_response);
//         this.aiSpeaking = false;
//       }

//       if (this.conversationActive) setTimeout(() => this.startListeningCycle(), 200);

//     } catch (err) {
//       console.error('Error processing audio:', err);
//       if (this.conversationActive) setTimeout(() => this.startListeningCycle(), 1500);
//     }
//   }

//   // -------------------------------
//   // Text-to-speech
//   // -------------------------------
//   async speakText(text: string) {
//     return new Promise<void>((resolve) => {
//       if (!('speechSynthesis' in window)) return resolve();
//       speechSynthesis.cancel();

//       const utterance = new SpeechSynthesisUtterance(text);
//       utterance.lang = this.currentLanguage || 'en-US';
//       utterance.rate = 1;
//       utterance.pitch = 1;

//       utterance.onend = () => resolve();
//       speechSynthesis.speak(utterance);
//     });
//   }

//   // -------------------------------
//   // Continuous user interruption monitor
//   // -------------------------------
//   private monitorUserInterruption() {
//     if (!this.analyser) return;
//     const dataArray = new Uint8Array(this.analyser.frequencyBinCount);
//     const threshold = 0.02;
//     let consecutiveFrames = 0;

//     const check = () => {
//       if (!this.conversationActive) return;

//       this.analyser.getByteTimeDomainData(dataArray);

//       let sum = 0;
//       for (let i = 0; i < dataArray.length; i++) {
//         const norm = (dataArray[i] - 128) / 128;
//         sum += norm * norm;
//       }
//       const rms = Math.sqrt(sum / dataArray.length);

//       if (rms > threshold) {
//         consecutiveFrames++;
//         if (consecutiveFrames >= 3 && this.aiSpeaking) {
//           console.log('🗣 User interrupted AI!');
//           this.interruptionDetected = true;
//           if (speechSynthesis.speaking) speechSynthesis.cancel();
//           if (!this.audioPlayer.paused) {
//             this.audioPlayer.pause();
//             this.audioPlayer.currentTime = 0;
//           }
//           this.aiSpeaking = false;
//           this.statusText = '⚡ Interrupted! Listening...';
//           this.statusClass = 'interrupted';
//           this.startListeningCycle();
//         }
//       } else consecutiveFrames = 0;

//       requestAnimationFrame(check);
//     };

//     check();
//   }
  animationFrameId: number | null = null;
  restartTimeout: any = null;
  currentUtterance: SpeechSynthesisUtterance | null = null;

async toggleConversation() {
    if (this.conversationActive) {
      this.stopConversation();
    } else {
      await this.startConversation();
    }
  }
 
  // -------------------------------
  // Start conversation
  // -------------------------------
  async startConversation() {
    try {
      this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
 
      this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      const source = this.audioContext.createMediaStreamSource(this.mediaStream);
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 2048;
      source.connect(this.analyser);
 
      this.conversationActive = true;
      this.showEmptyState = false;
      this.statusText = 'Listening...';
      this.statusClass = 'listening';
 
      this.monitorUserInterruption(); // Continuous VAD
      this.startListeningCycle();     // Start first recording
    } catch (err) {
      console.error('Microphone error:', err);
      this.statusText = 'Could not access microphone';
      this.statusClass = 'error';
    }
  }
 
  // -------------------------------
  // Stop conversation
  // -------------------------------
  stopConversation() {
    console.log('Stopping conversation...');
 
    this.conversationActive = false;
    this.aiSpeaking = false;
    this.interruptionDetected = true;
 
    // Stop microphone
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
      this.mediaStream = null;
    }
 
    // Stop recorder
    if (this.mediaRecorder && this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.stop();
    }
 
    // Stop audio playback
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer.currentTime = 0;
      this.audioPlayer.src = ''; // remove source to prevent replay
    }
 
    // Stop speech synthesis
    if ('speechSynthesis' in window) {
      speechSynthesis.cancel();
    }
    if (this.currentUtterance) {
      this.currentUtterance = null;
    }
 
    // Stop any intervals / monitoring loops
    if (this.vadCheckInterval) {
      clearInterval(this.vadCheckInterval);
      this.vadCheckInterval = null;
    }
    if (this.silenceTimeout) {
      clearTimeout(this.silenceTimeout);
      this.silenceTimeout = null;
    }
    if (this.restartTimeout) {
      clearTimeout(this.restartTimeout);
      this.restartTimeout = null;
    }
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
 
    // Reset UI
    this.statusText = 'Tap to start conversation';
    this.statusClass = '';
    this.waveformActive = false;
 
    console.log('Conversation fully stopped.');
  }
 
  // -------------------------------
  // Listening cycle
  // -------------------------------
  async startListeningCycle() {
    if (!this.conversationActive || !this.mediaStream || this.aiSpeaking) return;
 
    this.aiSpeaking = false;
    this.interruptionDetected = false;
 
    const chunks: BlobPart[] = [];
    const recorder = new MediaRecorder(this.mediaStream);
    this.mediaRecorder = recorder;
 
    recorder.ondataavailable = (e) => { if (e.data.size > 0) chunks.push(e.data); };
 
    recorder.onstop = async () => {
      if (!this.conversationActive) return;
      const audioBlob = new Blob(chunks, { type: 'audio/webm' });
      await this.processVoiceAndRespond(audioBlob);
    };
 
    recorder.start();
    this.statusText = 'Listening... Speak now';
    this.statusClass = 'listening';
    this.waveformActive = true;
 
    // Auto-stop after 8 seconds
    this.silenceTimeout = setTimeout(() => { 
      if (recorder.state === 'recording') recorder.stop(); 
    }, 8000);
  }
 
  // -------------------------------
  // Process audio → API
  // -------------------------------
  async processVoiceAndRespond(audioBlob: Blob) {
    if (!this.conversationActive) return;
 
    try {
      const formData = new FormData();
      formData.append('audio_file', audioBlob, 'recording.webm');
      formData.append('language', this.currentLanguage);
      formData.append('action', 'voice_chat');
      formData.append('user_id', 'voice_user');
 
      const response = await fetch(`${this.API_BASE_URL}api/voice/stream`, { method: 'POST', body: formData });
      if (!response.ok) throw new Error('API call failed');
 
      const data = await response.json();
      if (data.transcribed_text) this.addMessage('user', data.transcribed_text);
      // if (data.ai_response) {
      //   this.addMessage('bot', data.ai_response);
 
      //   this.aiSpeaking = true;
      //   await this.speakText(data.ai_response);
      //   this.aiSpeaking = false;
      // }
      if (data.ai_response) {
  const messageIndex = this.messages.length;
  this.addMessage('bot', ''); // Start empty so we can update gradually
  this.stopRecording();
  this.aiSpeaking = true;
  await this.speakTextStreaming(data.ai_response, messageIndex);
  this.aiSpeaking = false;
}
 
      if (this.conversationActive) {
        this.restartTimeout = setTimeout(() => this.startListeningCycle(), 200);
      }
 
    } catch (err) {
      console.error('Error processing audio:', err);
      if (this.conversationActive) {
        this.restartTimeout = setTimeout(() => this.startListeningCycle(), 1500);
      }
    }
  }
//70 % working  
//   async speakTextStreaming(fullText: string, messageIndex: number): Promise<void> {
//   return new Promise<void>((resolve) => {
//     if (!('speechSynthesis' in window)) {
//       console.warn('Speech synthesis not supported.');
//       return resolve();
//     }

//     // Cancel any ongoing speech
//     speechSynthesis.cancel();

//     const utterance = new SpeechSynthesisUtterance();
//     utterance.lang = this.currentLanguage || 'en-US';
//     utterance.rate = 1;
//     utterance.pitch = 1;

//     // Split text into words
//     const words = fullText.split(/\s+/);
//     let currentWord = 0;
//     this.messages[messageIndex].text = ''; // reset

//     const speakNextChunk = () => {
//       if (currentWord >= words.length) {
//         // Finished all words
//         resolve();
//         return;
//       }

//       // Take small chunk of 5–8 words at a time for smooth sync
//       const chunk = words.slice(currentWord, currentWord + 6).join(' ');
//       currentWord += 6;

//       // Update chat text gradually
//       this.messages[messageIndex].text += (this.messages[messageIndex].text ? ' ' : '') + chunk;
//       this.cdr.detectChanges();
//       this.scrollToBottom();

//       // Speak this chunk
//       utterance.text = chunk;
//       speechSynthesis.speak(utterance);
//     };

//     utterance.onend = () => {
//       // When one chunk finishes, go for next chunk
//       if (currentWord < words.length) {
//         setTimeout(speakNextChunk, 200);
//       } else {
//         resolve();
//       }
//     };

//     // Start streaming speech + text
//     speakNextChunk();
//   });
// }
//reading word to word as we expexted
 async speakTextStreaming(fullText: string, messageIndex: number): Promise<void> {
  return new Promise<void>((resolve) => {
    if (!('speechSynthesis' in window)) {
      console.warn('Speech synthesis not supported.');
      return resolve();
    }

    // Cancel ongoing speech
    speechSynthesis.cancel();

    // Prepare utterance
    const utterance = new SpeechSynthesisUtterance(fullText);
    utterance.lang = this.currentLanguage || 'en-US';
    utterance.rate = 1.05; // slightly natural speed
    utterance.pitch = 1;

    const words = fullText.split(/\s+/);
    this.messages[messageIndex].text = ''; // reset before streaming
    let currentWordIndex = 0;

    // Typing speed (milliseconds per word)
    const typingDelay = 160;

    // Show words gradually in sync
    const typingInterval = setInterval(() => {
      if (currentWordIndex < words.length) {
        this.messages[messageIndex].text +=
          (this.messages[messageIndex].text ? ' ' : '') + words[currentWordIndex];
        this.cdr.detectChanges();
        this.scrollToBottom();
        currentWordIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, typingDelay);

    // Start speaking full sentence immediately (in parallel)
    speechSynthesis.speak(utterance);

    utterance.onend = () => {
      clearInterval(typingInterval);
      // ensure full text visible at end
      this.messages[messageIndex].text = fullText;
      this.cdr.detectChanges();
      resolve();
    };
  });
}

  // -------------------------------
  // Text-to-speech
  // -------------------------------
  async speakText(text: string) {
    return new Promise<void>((resolve) => {
      if (!('speechSynthesis' in window)) return resolve();
      speechSynthesis.cancel();
 
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = this.currentLanguage || 'en-US';
      utterance.rate = 1;
      utterance.pitch = 1;
 
      utterance.onend = () => {
        if (this.conversationActive) {
          this.aiSpeaking = false;
        }
        resolve();
      };
 
      utterance.onerror = (e) => {
        if (this.conversationActive) {
          this.aiSpeaking = false;
        }
        resolve(); // still resolve to avoid hanging
      };
 
      this.currentUtterance = utterance;
 
      speechSynthesis.speak(utterance);
    });
  }
 
  // -------------------------------
  // Continuous user interruption monitor
  // -------------------------------
  private monitorUserInterruption() {
    if (!this.analyser) return;
    const dataArray = new Uint8Array(this.analyser.frequencyBinCount);
    const threshold = 0.02;
    let consecutiveFrames = 0;
 
    const check = () => {
      if (!this.conversationActive || !this.analyser) return;
 
      this.analyser.getByteTimeDomainData(dataArray);
 
      let sum = 0;
      for (let i = 0; i < dataArray.length; i++) {
        const norm = (dataArray[i] - 128) / 128;
        sum += norm * norm;
      }
      const rms = Math.sqrt(sum / dataArray.length);
 
      if (rms > threshold) {
        consecutiveFrames++;
        if (consecutiveFrames >= 3 && this.aiSpeaking) {
          console.log('🗣 User interrupted AI!');
          this.interruptionDetected = true;
          if (speechSynthesis.speaking) speechSynthesis.cancel();
          if (this.audioPlayer && !this.audioPlayer.paused) {
            this.audioPlayer.pause();
            this.audioPlayer.currentTime = 0;
          }
          this.aiSpeaking = false;
          this.statusText = '⚡ Interrupted! Listening...';
          this.statusClass = 'interrupted';
          this.startListeningCycle();
        }
      } else consecutiveFrames = 0;
 
      this.animationFrameId = requestAnimationFrame(check);
    };
 
    this.animationFrameId = requestAnimationFrame(check);
  }

    loadingHistory = false; conversationList: any[] = []; conversationId: string = '';
    showHistory = false; private shouldScrollToBottom = false;

    async loadConversationHistory() {
    this.loadingHistory = true;
    
    try {
      console.log('Fetching conversation history from:', `${this.API_BASE_URL}api/chat/conversations/web_user`);
      
      const response = await fetch(`${this.API_BASE_URL}api/chat/conversations/web_user`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      
      // console.log('Conversation history response:', data);
      // console.log('Number of conversations:', Object.keys(data.conversations || {}).length);
      
      // Transform conversations into list format
      this.conversationList = [];
      
      if (data.conversations && Object.keys(data.conversations).length > 0) {
        for (const [convId, messages] of Object.entries(data.conversations)) {
          const messageArray = messages as any[];
          
          if (messageArray && messageArray.length > 0) {
            // Get first user message as title
            const firstUserMsg = messageArray.find((m: any) => m.role === 'user');
            const title = firstUserMsg ? 
              (firstUserMsg.content.substring(0, 50) + (firstUserMsg.content.length > 50 ? '...' : '')) : 
              'Untitled Conversation';
            
            // Get last message as preview
            const lastMsg = messageArray[messageArray.length - 1];
            const preview = lastMsg ? 
              (lastMsg.content.substring(0, 60) + (lastMsg.content.length > 60 ? '...' : '')) : 
              '';
            
            // Get date from last message
            const date = lastMsg?.timestamp ? 
              new Date(lastMsg.timestamp).toLocaleDateString() : 
              'Unknown date';
            
            this.conversationList.push({
              conversation_id: convId,
              title: title,
              preview: preview,
              date: date,
              message_count: messageArray.length,
              messages: messageArray,
              isCurrentSession: convId === this.conversationId // Mark current conversation
            });
          }
        }
        
        // Sort by most recent first (based on conversation_id which has timestamp)
        this.conversationList.sort((a, b) => b.conversation_id.localeCompare(a.conversation_id));
      }
      
      console.log('Processed conversation list:', this.conversationList);
      console.log('Setting loadingHistory to false');
      
    } catch (error) {
      console.error('Error loading conversation history:', error);
    } finally {
      this.loadingHistory = false;
      console.log('loadingHistory is now:', this.loadingHistory);
    }
  }


  async loadConversation(convId: string) {
    try {
      console.log('Loading conversation:', convId);
      
      // Find conversation in list
      const conv = this.conversationList.find(c => c.conversation_id === convId);
      
      if (!conv || !conv.messages) {
        console.error('Conversation not found or has no messages');
        return;
      }
      
      // Clear current messages
      this.messages = [
        { from: 'bot', text: "Hello! I'm your healthcare assistant. How can I help you today?" }
      ];
      
      // Load messages from conversation
      for (const msg of conv.messages) {
        const from = msg.role === 'user' ? 'user' : 'bot';
        this.messages.push({
          from: from,
          text: msg.content,
          type: 'text'
        });
      }
      
      // Set conversation ID
      this.conversationId = convId;
      
      // Close history sidebar
      this.showHistory = false;
      
      // Scroll to bottom
      this.shouldScrollToBottom = true;
      
      console.log('Loaded conversation with', this.messages.length, 'messages');
      
    } catch (error) {
      console.error('Error loading conversation:', error);
      this.addMessage('bot', 'Error loading conversation.');
    }
  }

   async deleteConversation(conversationId: string, event: Event) {
    // Prevent triggering conversation load when clicking delete
    event.stopPropagation();
    
    // Confirm deletion
    if (!confirm('Are you sure you want to delete this conversation? This action cannot be undone.')) {
      return;
    }
    
    try {
      console.log('Deleting conversation:', conversationId);
      
      const response = await fetch(`${this.API_BASE_URL}api/chat/conversations/${conversationId}`, {
        method: 'DELETE'
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('✅ Conversation deleted successfully:', result.message);
        
        // If we deleted the current conversation, reset to new conversation
        if (this.conversationId === conversationId) {
          this.conversationId = `web_user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          this.messages = [
            { from: 'bot', text: "Hello! I'm your healthcare assistant. How can I help you today?" }
          ];
          console.log('Reset to new conversation ID:', this.conversationId);
        }
        
        // Refresh history to remove deleted conversation
        await this.loadConversationHistory();
        
        // Show success message briefly
        const tempMessage = { from: 'bot' as const, text: '🗑️ Conversation deleted successfully.', type: 'text' as const };
        this.messages.push(tempMessage);
        this.cdr.detectChanges();
        
        setTimeout(() => {
          // Remove the success message after 3 seconds
          const index = this.messages.indexOf(tempMessage);
          if (index > -1) {
            this.messages.splice(index, 1);
            this.cdr.detectChanges();
          }
        }, 3000);
        
      } else {
        const errorData = await response.json();
        console.error('❌ Failed to delete conversation:', errorData);
        alert('Failed to delete conversation. Please try again.');
      }
    } catch (error) {
      console.error('❌ Error deleting conversation:', error);
      alert('Error deleting conversation. Please try again.');
    }
  }



  toggleOptions() { }

  onVoiceChatClick() { this.toggleVoiceChat(); }
  onUploadClick() { if (this.fileInput) this.fileInput.nativeElement.click(); }
  onHealthTipsClick() { this.getHealthTips(); }
isTableHTML(text: string): boolean {
  if (!text) return false;

  // Strict check: only tables
  return /<table\b[^>]*>/i.test(text);
}

exportTableToExcel(): void {
  const payload = {
    filename: 'healthcare_data',
    sql: this.askeddata.sql
  };

  let api = `ask/export_excel`;

  this.AuthenticationService.postTemplatewithoutlogin(api, payload, payload.filename);

//   this.http.post('export_excel', payload).subscribe({
//   next: (res) => {
//     console.log('API success', res);
//   },
//   error: (err) => {
//     console.error('API error', err);
//   }
// });
}


createHTMLForMessage(msgHtml: string): string {
  // If msgHtml is empty, provide a minimal placeholder table
  if (!msgHtml) {
    msgHtml = '<table><tr><td>No data available</td></tr></table>';
  }

  const lower = msgHtml.toLowerCase();
  const looksLikeFullHtml =
    lower.includes('<!doctype') ||
    lower.includes('<html') ||
    lower.includes('<head');

  // If it's already full HTML, return as is
  if (looksLikeFullHtml) return msgHtml;

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8" />
  <style>
    body {
      margin: 0;
      padding: 10px;
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }

    table {
      width: 100% !important;
      border-collapse: collapse !important;
      border: 1px solid #333 !important;
    }

    th {
      background-color: #db0c8c !important;
      color: #fff;
      padding: 12px !important;
      border: 1px solid #ffffff33 !important;
      text-align: center;
    }

    td {
      border: 1px solid #ccc !important;
      padding: 10px !important;
      text-align: center;
      font-size: 13px;
    }

    tbody tr:nth-child(even) {
      background-color: #f7f7f7;
    }

    .export-btn {
      margin-bottom: 10px;
      padding: 8px 14px;
      background: #db0c8c;
      color: #fff;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
    }

    .export-btn:hover {
      opacity: 0.9;
    }
  </style>
</head>
<body>

 

  <!-- TABLE CONTENT -->
  ${msgHtml}
 <!-- EXPORT BUTTON -->
  <button class="export-btn"
    onclick="window.parent.postMessage({ type: 'EXPORT' }, '*')">
    Export to Excel
  </button>


</body>
</html>`;
}

// <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>


onIframeLoad(event: Event, msg: any): void {
  const iframe = event.target as HTMLIFrameElement;

  window.addEventListener(
    'message',
    (e: MessageEvent) => {
      const height = Number(e.data);
      if (!isNaN(height) && height > 0) {
        msg.webviewHeight = Math.min(height + 20, 800);
      }
    },
    { once: true } // 🔥 important
  );

}


getIframeHtml(msg: any): SafeHtml {
  const html = this.sanitizer.bypassSecurityTrustHtml(
    this.createHTMLForMessage(msg.text)
  );
  return html;
}
  
handleReportClick(message:string){
  this.userInput = message;
  setTimeout(() => {
     this.sendMessage();
  }, 300);
 
}

toggleTheme(event: any) {
  this.isDarkMode = !this.isDarkMode
  const chat = document.querySelector('.chat-card');
  if (!chat) return;

  chat.classList.toggle('dark', event.target.checked);
  chat.classList.toggle('light', !event.target.checked);
}






}

